import { render, staticRenderFns } from "./CPageStoreDetailStandard.vue?vue&type=template&id=fefee696&"
import script from "./CPageStoreDetailStandard.vue?vue&type=script&lang=ts&"
export * from "./CPageStoreDetailStandard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports